import React from "react";

const Badge = ({ label, BadgeClass }) => {
  return <div className={BadgeClass}>{label}</div>;
};

export default Badge;
